import { NavLink } from "react-router-dom"
import { useState } from "react"

interface NavButtonProps {
    href: string
    children: React.ReactNode
    className?: string
    external?: boolean
}

function NavButton({ href, children, className = "", external = false }: NavButtonProps) {
    const commonClasses = `flex items-center justify-center rounded-full font-bold border border-main text-main
        px-8 py-4 text-sm font-sans uppercase tracking-[0.25em] text-center
        transition-all duration-300 hover:bg-main/10 hover:border-main/50
        ${className}`;

    if (external) {
        return <a href={href} className={commonClasses}>{children}</a>;
    }

    return <NavLink to={href} className={commonClasses}>{children}</NavLink>;
}

const cartaItems = [
    { label: "Desde la Cocina", url: "https://drive.google.com/file/d/1THiXoNuHqdt06X6KxaIifIdv01YVpGuh/view?usp=drivesdk" },
    { label: "Para Brindar", url: "https://drive.google.com/file/d/1ZJCTX6C_3opo6D-QwI15LqgjUq87dv9_/view?usp=drivesdk" },
    { label: "Selección de Bodega", url: "https://drive.google.com/file/d/1MIJVii49u5bUVhe5D-5yFVWOBzYyJpLV/view?usp=drivesdk" },
    { label: "Cierre de Oro", url: "https://drive.google.com/file/d/1SWOi8yNOMQwluuThFgYGFrOgPQ98AHbK/view?usp=drivesdks" },
    { label: "El Ejecutivo", url: "https://drive.google.com/file/d/14rGcBam8Ktrhy8bWAJnkHNAHoO4dq_op/view?usp=drivesdk" },
]

export function NavButtons() {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <nav className="flex flex-col items-center gap-4 w-full max-w-lg mx-auto px-4">

            {/* CARTA */}
            <div className="w-full border border-main transition-all duration-400 overflow-hidden rounded-4xl">

                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className={`w-full flex items-center justify-center gap-2 font-bold text-main
                        px-8 py-3 text-sm font-sans uppercase tracking-[0.25em] relative text-center
                        transition-all duration-300 hover:bg-main/10
                    `}
                >

                    Carta
                    <svg
                        className={`w-4 h-4 transition-transform duration-300 absolute right-8 ${isOpen ? "rotate-180" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>

                {/* CONTENIDO */}
                <div
                    className={`transition-all duration-300 ease-in-out overflow-hidden
                        ${isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}
                    `}
                >
                    {cartaItems.map((item, index) => (
                        <a
                            key={item.label}
                            href={item.url}
                            className={`flex items-center justify-center w-full px-8 py-2  text-sm tracking-[0.25em] text-main
                                transition-all duration-200 hover:bg-main/10
                            `}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>

            </div>

            {/* GRID PARA PEDIDOS Y RESERVAR */}
            <div className="grid grid-cols-2 gap-4 w-full">
                <NavButton href="https://restaurante.elgabanoficial.com/" external className="w-full px-2 text-[10px] sm:text-xs">
                    Pedidos Online
                </NavButton>

                <NavButton
                    href="https://www.covermanager.com/reservation/module_restaurant/el-gaban/spanish"
                    external
                    className="w-full px-2 text-[10px] sm:text-xs"
                >
                    Reservar
                </NavButton>
            </div>

            {/* GELATILANDIA */}
            <NavButton
                href="https://docs.google.com/forms/d/e/1FAIpQLSdy9mHDE0l3k0WRyfmMrR_5Bi0Ao6VwJxOXEQ_qralGhRZMbA/viewform"
                external
                className="w-full text-[10px] sm:text-xs px-4"
            >
                Gelatilandia • Normas de Uso
            </NavButton>

        </nav>
    )
}
